<div class="hello-band py-4">
	<div class="container">
		<div class="row">
			 <div class="col-12">
			 	<h1 class="font-weight-bold">Je zit HELEMAAL verkeerd</h1>
			</div>
		</div>
	</div>
</div>
<div class="container py-5">
	<div class="row">
		<div class="col-md-6">
			<p>Oke, mijn fout. De pagina die je zocht kon niet worden gevonden, mogelijk bestaat hij niet of hebben we hem verhuisd. Helaasj. Ga terug naar de hoofdpagina of <a href="./">klik hier</a>.</p>
		</div>
		<div class="col-md-6 text-center">
			<img src="{{randomGif}}" alt="Een plaatje van SpongeBob." class="w-100" />
		</div>
	</div>
</div>